export enum AuthenticateState {
  PENDING,
  GUEST,
  WALLET,
}
export type SocialConnectionPage = "FriendList" | "ChatList" | "Chat";
export enum TaskStateType {
  SUCCESS,
  FAIL,
}

export enum KeypairState {
  PENDING,
  WAITING_KEY_AUTH,
  KEYPAIR_SUCCESS,
}

export type TMessage = {
  /** message uuid */
  id: string;
  /** when the message is created*/
  createdAt?: string;
  /** the address of the sender */
  fromAddress: string;
  /** the address of the reciever */
  toAddress: string;
  /** encrypted messageText*/
  messageText: string;
  /** check if the msg has been sended to dm server*/
  sended: boolean;
  /**
   * sha256 hash of the plaintext messageText
   * usecase: check if the decryption is successful
   */
  msgSha256Base64: string;
  /** public key of the fromAddress when the message is encrypted */
  fromPubKeyBase64: string;
  /** public key of the toAddress when the message is encrypted */
  toPubKeyBase64: string;
  /** always false now */
  cid: string;
  /** decrypted messageText*/
  plaintextMessage: string;

  available?: boolean;

  price?: number;

  currency?: string;

  item_status?: number;

  chain_id?: any;
};

export type TBToCMessage = {
  /** message uuid */
  id: string;
  /** when the message is created*/
  createdAt?: string;
  /** the address of the sender */
  fromAddress: string;
  /** the address of the reciever */
  toDomain: string;
  /** messageType*/
  messageType: string;
  /** messageText*/
  messageText: string;
  /** check if the msg has been sended to dm server*/
  sended: boolean;
  message_reference?: any;
  referenced_message?: any;
  message_count?: number;
  logoUrl?: string;
};
export interface EasterEggAvailability {
  hasEasterEgg: boolean;
  imageURL: string;
}

export type AIAvatarMetadata = {
  id: string;
  language: string;
  locale_category: string | null;
  accessories: string | null;
  actions: string | null;
  art_style: string | null;
  background: string | null;
  species: string | null;
  name: string | null;
  story: string | null;
  abilities: string | null;
  ai_avatar: string | null;
};
export type AIAvatarData = {
  id: string;
  level: string;
  category: string;
  prompt: string;
  image_path: string;
  is_used: boolean;
  used_at: string;
  created_at: string;
  metadata: AIAvatarMetadata[];
};
